import { Constants } from 'src/app/_helpers';
import { Component, OnInit, OnDestroy, Renderer2 } from '@angular/core';
import { DrawService, AlertService, CommonService, AuthenticationService, ToastService, ChatService } from 'src/app/_services';
import { filter, delay, first } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { Router, ActivationEnd } from '@angular/router';

@Component({
  selector: 'app-lotto-amigo',
  templateUrl: './lotto-amigo.component.html',
  styleUrls: ['./lotto-amigo.component.css']
})
export class LottoAmigoComponent implements OnInit {
  gameCode=Constants.BingoSeventyFive3;
  gameId;
  panelNumberCounter;
  gameData: any;
  userData: any;
  rootData: any;
  betAmtArray = [];
  isSidePanel = false;
  betData = {};
  userInfo: any;
  tempCounter = 0;
  fetchDataStatus = false;
  diff_time: any;
  postState = true;
  postStateMsg = '';
  gameFetchCounter = 0;
  myTicketCount = 0;
  gameSchemas = [];
  cardArray = [];
  timeIntervalContainer: any;
  postStateInterval: any;
  resetUserDataSubscription: any;
  updateUserDataSubscription: any;
  gameDataSubscription: any;
  quickPickDataSubscription: any;
  routeSubscription: any;
  resetPlaySubscription: any;
  userInfoLocalSubscription: any;
  notifyDrawMachineSubscription: any;
  ticketListSubscription: any;
  notifyTktLstSubscription: any;
  user: String;
  room: String;
  messageText: String;
  messageArray: Array<{ user: String, message: String }> = [];
  userCountSubscription: any;
  currentRoom = {};
  playerAdded = false;
  chatAppEnable = false;
  saleTimerStatus = false;
  activeDrawStatus = true;
  loadLobby: boolean = true;
  clientCode = Constants.CLIENT_CODE;

  constructor(private drawService: DrawService,
    private alertService: AlertService,
    private renderer: Renderer2,
    private commonService: CommonService,
    private authenticationService: AuthenticationService,
    private translate: TranslateService,
    private router: Router,
    private toastService: ToastService,
    private chatService: ChatService
  ) {
    this.routeSubscription = router.events.pipe(
      filter(e => e instanceof ActivationEnd && typeof e.snapshot.data.gameCode != 'undefined'),
      first()
    ).subscribe(val => {
      this.gameCode = (<any>val).snapshot.data.gameCode;
      this.rootData = Constants.GAME_DATA[Constants.DRAW_ENGINE][this.gameCode];
      let tempVar = <any>val;
      let params = tempVar.snapshot.params;
      if (typeof params.playerid != 'undefined' && typeof params.playername != 'undefined' &&
        typeof params.sessid != 'undefined' && typeof params.bal != 'undefined' &&
        typeof params.lang != 'undefined' && typeof params.curr != 'undefined' &&
        typeof params.alias != 'undefined' && typeof params.isMobileApp != 'undefined') {
        this.loadLobby = false;
      }
      if(params.isMobileApp == 0) {
        this.loadLobby = true;
      }
      this.commonService.iframe_resize();
    });
  }
                   
  ngOnInit() {
    this.commonService.addEngineClass();

    // this.chatService.resetChat();

    if (!this.chatService.isConnected()) {
      this.chatService.connect();
      this.playerAdded = false;
    }

    this.gameDataSubscription = this.drawService.subscribeGameData().pipe(
      delay(0),
      filter(response => response != null && typeof response.data.responseData.gameRespVOs[0].numberConfig != 'undefined')
    ).subscribe((response: any) => {
      response.data.responseData.gameRespVOs.forEach(element => {
        if (element.gameCode == this.gameCode) {
          this.gameData = JSON.parse(JSON.stringify(element));
          this.gameId = element.id;
          if (this.gameFetchCounter == 0) {
            if (response.timerType == this.gameCode || response.timerType == '') {
              this.resetUserData();
            }
          }
          this.betAmtArray = [];
          for (let i = 0; i < element.betRespVOs.length; i++) {
            this.betData[element.betRespVOs[i].betCode] = JSON.parse(JSON.stringify(element.betRespVOs[i]));
            let tempVar = {};
            for (let j = 0; j < this.betData[element.betRespVOs[i].betCode].pickTypeData.pickType.length; j++) {
              tempVar[element.betRespVOs[i].pickTypeData.pickType[j].code] = this.betData[element.betRespVOs[i].betCode].pickTypeData.pickType[j];
            }
            this.betData[element.betRespVOs[i].betCode].pickTypeData.pickType = tempVar;
          }
          let betArrayLength = Math.floor(element.betRespVOs[0].maxBetAmtMul);
          betArrayLength = (betArrayLength > 8) ? 9 : betArrayLength;
          if (element.betRespVOs[0].unitPrice <= 1) {
            for (let i = 1; i <= betArrayLength; i++) {
              if (element.betRespVOs[0].unitPrice * i * 10 <= element.betRespVOs[0].maxBetAmtMul * element.betRespVOs[0].unitPrice) {
                this.betAmtArray.push(element.betRespVOs[0].unitPrice * i * 10);
              }
            }
          } else {
            for (let i = 1; i <= betArrayLength; i++) {
              if (element.betRespVOs[0].unitPrice * i <= element.betRespVOs[0].maxBetAmtMul * element.betRespVOs[0].unitPrice) {
                this.betAmtArray.push(element.betRespVOs[0].unitPrice * i);
              }
            }
          }
          this.gameSchemas = [];
          if (typeof element.gameSchemas != 'undefined') {
            for (let i = 0; i < element.gameSchemas.matchDetail.length; i++) {
              this.gameSchemas[element.gameSchemas.matchDetail[i].betType] = JSON.parse(JSON.stringify(element.gameSchemas.matchDetail[i]));
            }
          }
          this.fetchDataStatus = true;
          this.tempCounter = 0;
          clearInterval(this.timeIntervalContainer);
          if (response.timerType == element.gameCode || response.timerType == "") {
            let tempTime = 0;
            let tempTime2 = 0;
            let fetchRuleStatus = true;
            if (element.drawRespVOs.length != 0) {
              // tempTime = Math.floor((new Date(element.timeToFetchUpdatedGameInfo.replace(/-/g, "/")).getTime() - new Date().getTime()) / 1000);
              tempTime = Math.floor((new Date(this.drawService.changeDateFormat(element.timeToFetchUpdatedGameInfo)).getTime() - DrawService.gameTime) / 1000);
              if (typeof element.drawRespVOs[0].drawSaleStartTime != 'undefined') {
                tempTime2 = Math.floor((new Date(this.drawService.changeDateFormat(element.drawRespVOs[0].drawSaleStartTime)).getTime() - DrawService.gameTime) / 1000);
              }
            } else {
              this.activeDrawStatus = false;
              this.renderer.addClass(document.body, 'modal-fix');
            }
            this.diff_time = {
              totalTime: tempTime >= 0 ? tempTime : 0,
              shownTime: ['00', '00', '00', '00'],
              convention: 'sec',
              saleStartTime: tempTime2 >= 0 ? tempTime2 : 0,
              saleShownTime: ['00', '00', '00', '00'],
              saleConvention: 'sec',
              fetchRuleStatus: fetchRuleStatus
            }
          }
          ++this.gameFetchCounter;
          this.qpNumbers();
        }
      });
      this.fetchPlayerTicketList();
      this.updateClock();
      this.timeIntervalContainer = setInterval(() => {
        this.updateClock();
      }, 1000);
      this.commonService.iframe_resize();
    });

    this.resetPlaySubscription = this.drawService.subscribeResetPlayUserData().subscribe((response) => {
      if (response.status) {
        this.isSidePanel = false;
        this.resetUserData();
      }
      this.commonService.iframe_resize();
    });

    this.userInfoLocalSubscription = this.authenticationService.subscribeuserInfoLocal().subscribe((response) => {
      this.userInfo = response;
      if (!this.playerAdded && typeof this.userInfo.sessid != 'undefined' && this.userInfo.sessid != '-') {
        this.chatService.serverAddUser(this.userInfo.playername);
        this.chatService.serverJoinRoom(this.gameCode);
        this.chatService.joinRoom({ user: this.userInfo.playername, room: this.gameCode });
        // this.chatAppEnable = true;
        this.playerAdded = true;
      }
      this.chatService.serverRoomList();
      this.commonService.iframe_resize();
    });

    this.authenticationService.getUserInfoLocal();

    this.notifyTktLstSubscription = this.drawService.subscribeTicketList().subscribe((response) => {
      this.fetchPlayerTicketList();
      this.qpNumbers();
    });

    // this.resetUserDataSubscription = this.drawService.subscribeResetUserData().subscribe((response: any) => {
    //   if (response.status) {
        // this.resetUserData();
    //   }
    //   this.commonService.iframe_resize();
    // });

    this.updateUserDataSubscription = this.drawService.subscribeUpdateUserData().subscribe((response: any) => {
      this.userData = response.userData;
      outerloop:
      for (let i = 0; i < this.cardArray.length; i++) {
        if (this.cardArray[i].selected) {
          if (this.userData.panelData.length > 0) {
            let status = false;
            for (let j = 0; j < this.userData.panelData.length; j++) {
              if (JSON.stringify(this.userData.panelData[j].pickedValues) == JSON.stringify(this.cardArray[i].numbers)) {
                status = true;
              }
            }
            if (status == false) {
              this.cardArray[i].selected = false;
              break outerloop;
            }
          } else {
            this.cardArray[i].selected = false;
          }
        }
      }
      this.commonService.iframe_resize();
    });

    this.userCountSubscription = this.chatService.userCount().pipe(delay(0)).subscribe((response: any) => {
      this.resetCurrentRooms();
      for (const key in response.roomlist) {
        this.currentRoom[key] = response.roomlist[key];
      }
    });

  }

  ngOnDestroy(): void {
    // this.chatService.resetChat();
    this.chatService.leaveRoom({ user: this.userInfo.playername, room: this.gameCode });
    this.removeBetPanels();
    this.renderer.removeClass(document.body, 'modal-open');
    this.renderer.removeClass(document.body, 'modal-fix');
    clearInterval(this.timeIntervalContainer);
    clearInterval(this.postStateInterval);
    if (typeof this.gameDataSubscription != 'undefined') {
      this.gameDataSubscription.unsubscribe();
    }
    if (typeof this.routeSubscription != 'undefined') {
      this.routeSubscription.unsubscribe();
    }
    if (typeof this.quickPickDataSubscription != 'undefined') {
      this.quickPickDataSubscription.unsubscribe();
    }
    if (typeof this.resetPlaySubscription != 'undefined') {
      this.resetPlaySubscription.unsubscribe();
    }
    if (typeof this.userInfoLocalSubscription != 'undefined') {
      this.userInfoLocalSubscription.unsubscribe();
    }
    if (typeof this.notifyDrawMachineSubscription != 'undefined') {
      this.notifyDrawMachineSubscription.unsubscribe();
    }
    if (typeof this.ticketListSubscription != 'undefined') {
      this.ticketListSubscription.unsubscribe();
    }
    if (typeof this.notifyTktLstSubscription != 'undefined') {
      this.notifyTktLstSubscription.unsubscribe();
    }
    if (typeof this.resetUserDataSubscription != 'undefined') {
      this.resetUserDataSubscription.unsubscribe();
    }
    if (typeof this.updateUserDataSubscription != 'undefined') {
      this.updateUserDataSubscription.unsubscribe();
    }
    // if (typeof this.userCountSubscription != 'undefined') {
    //   this.userCountSubscription.unsubscribe();
    // }
    this.commonService.iframe_resize();
  }

  removeBetPanels() {
    this.renderer.removeClass(document.getElementsByClassName('bodyWrapper')[0], 'vi-mainbet');
    this.renderer.removeClass(document.getElementsByClassName('bodyWrapper')[0], 'vi-sidebet');
    this.renderer.removeClass(document.getElementsByClassName('bodyWrapper')[0], 'vi-confirm');
    this.commonService.iframe_resize();
  }

  resetCurrentRooms() {
    for (const i in this.currentRoom) {
      this.currentRoom[i] = 0;
    }
  }

  fetchPlayerTicketList() {
    if (typeof this.userInfo == 'undefined' || this.userInfo.sessid == '-' || this.gameData.drawRespVOs.length == 0) {
      this.myTicketCount = 0;
      return false;
    }
    let temp = {
      gameCode: this.gameCode,
      orderBy: 'asc',
      pageSize: 100,
      pageIndex: 0,
      drawId: this.gameData.drawRespVOs[0].drawId,
      isBingoEnable:false,
    };
    this.ticketListSubscription = this.drawService.fetchPlayerTicketList(temp).subscribe((response: any) => {
      console.log(response,"ttyu",temp)
      if (typeof response != 'undefined' && typeof response.data != 'undefined' && response.data.responseCode == 0 && response.data.responseData.length > 0 && response.data.responseData[0].ticketList != null) {
        this.myTicketCount = response.data.responseData[0].ticketList.length;
      } else {
        this.myTicketCount = 0;
        // this.alertService.error(response.responseMessage);
      }
    });
  }

  calculateTotalPrice() {
    if (typeof this.userData != 'undefined') {
      let totalSum = 0;
      this.changePostState(true);
      for (let i = 0; i < this.userData.panelData.length; i++) {
        totalSum += this.calculatePanelPrice(i);
      }
      return totalSum;
    }
    return 0;
    this.commonService.iframe_resize();
  }

  calculatePanelPrice(pIndex) {
    if (typeof this.userData != 'undefined' && typeof this.betData[this.userData.panelData[pIndex].betType] != 'undefined') {
      let unitPrice = this.betData[this.userData.panelData[pIndex].betType].unitPrice;
      let betAmountMultiple = this.userData.panelData[pIndex].betAmountMultiple;
      return (unitPrice * betAmountMultiple * this.numberOfLines(pIndex) * this.userData.noOfDraws);
    }
    return 0;
    this.commonService.iframe_resize();
  }

  openHelpModal(gameCode) {
    this.drawService.openHelpPopup(true, gameCode);
    this.commonService.iframe_resize();
  }

  openDrawMachine() {
    if (this.myTicketCount > 0) {
      this.router.navigate(['/dge/draw-machine'], { fragment: this.gameCode });
    } else {
      return false;
    }
  }
  // openDrawMachine() {
  //   // if (this.myTicketCount > 0) {
  //   if(this.loadLobby) {
  //     this.router.navigate(['/dge/draw-machine'], { fragment: this.gameCode + ',' + this.gameId });
  //   } else {                                                                                                              //  because the app view
  //     this.router.navigate(['/dge/draw-machine/'+this.userInfo.playerid+'/'+this.userInfo.playername+'/'+this.userInfo.sessid+'/'+this.userInfo.balance+'/'+this.userInfo.lang+'/'+this.userInfo.curr+'/'+this.userInfo.currDisplay+'/'+this.userInfo.aliasName+'/1'], { fragment: this.gameCode + ',' + this.gameId });
  //   }
  //   //this.router.navigate(['/bingo/draw-machine'], { fragment: this.gameCode + ',' + this.gameId });
  //   // } else {
  //   //   return false;
  //   // }
  // }

  resetUserData() {
    this.userData = {
      // "currencyCode": (typeof this.gameData != 'undefined' && typeof this.gameData.currencyRespVOs != 'undefined') ? this.gameData.currencyRespVOs[0].currencyCode : '',
      "drawData": [],
      "gameCode": this.gameCode,
      "gameId": (typeof this.gameData != 'undefined' && typeof this.gameData.id != 'undefined') ? this.gameId : 0,
      "isAdvancePlay": false,
      "lastTicketNumber": 0,
      "noOfDraws": 1,
      "noOfPanel": 0,
      "panelData": [],
      "isUpdatedPayoutConfirmed": false,
    };
    this.panelNumberCounter = +this.gameData.maxPanelAllowed;
    this.postStateMsg = this.gameData.betRespVOs[0].pickTypeData.pickType[0].description;
    this.commonService.iframe_resize();
    this.cardArray.map((element) => element.selected = false);
  }


  selectPickedNum(index) {
    if (this.cardArray[index].selected == false && this.userData.panelData.length >= this.gameData.maxPanelAllowed) {
      this.toastService.error(this.translate.instant('dge.max_pan_err', { maxPanelAllowed: this.gameData.maxPanelAllowed }));
      return false;
    }
    this.cardArray[index].selected = !this.cardArray[index].selected;
    this.userData.panelData = [];
    this.cardArray.forEach(element => {
      if (element.selected) {
        this.userData.panelData.push({
          "betType": this.gameData.betRespVOs[0].betCode,
          "pickType": this.gameData.betRespVOs[0].pickTypeData.pickType[0].code,
          "pickConfig": this.gameData.betRespVOs[0].pickTypeData.pickType[0].range[0].pickConfig,
          "betAmountMultiple": (this.gameData.betRespVOs[0].unitPrice < 1) ? (this.gameData.betRespVOs[0].unitPrice * 10) : 1,
          "quickPick": true,
          "pickedValues": element.numbers,
          "qpPreGenerated": true
        });
      }
    });
    this.userData.noOfPanel = this.userData.panelData.length;
    this.commonService.iframe_resize();
  }

  enableChat() {
    if (typeof this.userInfo.sessid != 'undefined' && this.userInfo.sessid != '-') {
      this.chatAppEnable = !this.chatAppEnable;
      this.user = this.userInfo.playername;
    } else {
      this.commonService.openPlayerLogin();
    }
  }

  receiveMessage($event) {
    if ($event == 'close')
      this.chatAppEnable = false
  }

  updateClock() {
    if (this.diff_time.totalTime > -1 && this.diff_time.fetchRuleStatus) {
      let diff_day = Math.floor(this.diff_time.totalTime / (3600 * 24));
      let diff_hr = Math.floor((this.diff_time.totalTime % (3600 * 24)) / 3600);
      let diff_min = Math.floor((this.diff_time.totalTime % (3600)) / 60);
      let diff_sec = Math.floor(this.diff_time.totalTime % 60);
      this.diff_time.shownTime[0] = (diff_day > 9) ? '' + diff_day : '0' + diff_day;
      this.diff_time.shownTime[1] = (diff_hr > 9) ? '' + diff_hr : '0' + diff_hr;
      this.diff_time.shownTime[2] = (diff_min > 9) ? '' + diff_min : '0' + diff_min;
      this.diff_time.shownTime[3] = (diff_sec > 9) ? '' + diff_sec : '0' + diff_sec;
      if (diff_day > 0) {
        this.diff_time.convention = (diff_day == 1) ? 'day' : 'days';
      } else if (diff_hr > 0) {
        this.diff_time.convention = (diff_hr == 1) ? 'hr' : 'hrs';
      } else if (diff_min > 0) {
        this.diff_time.convention = (diff_min == 1) ? 'min' : 'mins';
      } else if (diff_sec > 0) {
        this.diff_time.convention = (diff_sec == 1) ? 'sec' : 'secs';
      } else {
        this.diff_time.convention = 'sec';
        ++this.tempCounter;
        if (this.fetchDataStatus || this.tempCounter == 1) {
          localStorage.removeItem(this.gameCode + '-bingoGameData');
          this.drawService.getGameData(Constants.DRAW_ENGINE, this.gameCode);
          // this.notifyDrawMachineSubscription = this.commonService.notifyDrawMachine({ 'engine': Constants.BINGO_ENGINE, 'gameCode': this.gameCode }).subscribe((response: any) => {
          // });
          // this.drawService.setLoaderStatus(true);
        }
        this.fetchDataStatus = false;
      }
      --this.diff_time.totalTime;
    }
    if (this.diff_time.saleStartTime > 0) {
      this.saleTimerStatus = true;
      this.renderer.addClass(document.body, 'modal-fix');
      let diff_day = Math.floor(this.diff_time.saleStartTime / (3600 * 24));
      let diff_hr = Math.floor((this.diff_time.saleStartTime % (3600 * 24)) / 3600);
      let diff_min = Math.floor((this.diff_time.saleStartTime % (3600)) / 60);
      let diff_sec = Math.floor(this.diff_time.saleStartTime % 60);
      this.diff_time.saleShownTime[0] = (diff_day > 9) ? '' + diff_day : '0' + diff_day;
      this.diff_time.saleShownTime[1] = (diff_hr > 9) ? '' + diff_hr : '0' + diff_hr;
      this.diff_time.saleShownTime[2] = (diff_min > 9) ? '' + diff_min : '0' + diff_min;
      this.diff_time.saleShownTime[3] = (diff_sec > 9) ? '' + diff_sec : '0' + diff_sec;
      if (diff_day > 0) {
        // this.diff_time.saleConvention = (diff_day == 1) ? 'day' : 'days';
        this.diff_time.convention = 'day';
      } else if (diff_hr > 0) {
        // this.diff_time.saleConvention = (diff_hr == 1) ? 'hr' : 'hrs';
        this.diff_time.convention = 'hr';
      } else if (diff_min > 0) {
        // this.diff_time.saleConvention = (diff_min == 1) ? 'min' : 'mins';
        this.diff_time.convention = 'min';
      } else if (diff_sec > 0) {
        // this.diff_time.saleConvention = (diff_sec == 1) ? 'sec' : 'secs';
        this.diff_time.convention = 'sec';
      } else {
        this.diff_time.saleConvention = 'sec';
      }
      --this.diff_time.saleStartTime;
    } else {
      this.saleTimerStatus = false;
      if (this.activeDrawStatus) {
        this.renderer.removeClass(document.body, 'modal-fix');
      }
    }
  }

  numberOfLines(purchasePanelIndex) {
    if (typeof this.userData != 'undefined') {
      if (this.userData.panelData[purchasePanelIndex].betType != '' && this.userData.panelData[purchasePanelIndex].pickedValues.length != 0) {
        this.changePostState(false);
        return 1;
      } else {
        this.changePostState(true);
        // this.postState = true;
        return 0;
      }
    } else {
      this.changePostState(true);
      // this.postState = true;
      return 0;
    }
    this.commonService.iframe_resize();
  }

  changePostState(val) {
    clearInterval(this.postStateInterval);
    this.postStateInterval = setInterval(() => {
      this.postState = val;
    }, 0);
  }

  qpNumbers() {
    let unSelectedCard = Constants.GAME_DATA[Constants.DRAW_ENGINE][this.gameCode].totalCards;
    this.cardArray = this.cardArray.filter((element) => element.selected);
    let qpData = {
      'gameCode': this.gameCode,
      'noOfLines': unSelectedCard - this.cardArray.length,
      'numbersPicked': 1
    };
    this.quickPickDataSubscription = this.drawService.getQuickPickData(qpData).subscribe((response: any) => {
      response.data.responseData.forEach(element => {
        let firstArray = element.split('#');
        let tempArray = [];
        firstArray.forEach(element1 => {
          let secondArray = element1.split(',');
          // let secondArray = element1.split(',').map((num) => {
          //   if (num.length == 1 && num != 'X')
          //     return '0' + num;
          //   else
          //     return num;
          // });
          tempArray.push(secondArray);
        });
        this.cardArray.push({
          selected: false,
          numbers: tempArray
        });
      });
      let tempUserData = this.commonService.getUserPurchaseData(Constants.DRAW_ENGINE);
      if (tempUserData) {
        delete tempUserData.extra;
        this.userData = JSON.parse(JSON.stringify(tempUserData));
        this.commonService.removeUserPurchaseData();
        this.purchaseTicket();
        for (let i = 0; i < this.userData.panelData.length; i++) {
          this.cardArray.splice(i, 1, {
            selected: true,
            numbers: this.userData.panelData[i].pickedValues
          });
        }
        // this.userData.panelData.foreach((element)=>{
        //   this.cardArray.push({
        //     selected: true,
        //     numbers: element.pickedValues
        //   });
        // });
      }
      this.cardArray.length = Constants.GAME_DATA[Constants.DRAW_ENGINE][this.gameCode].totalCards;
    });
    this.commonService.iframe_resize();
  }

  purchaseTicket() {
    if (this.userInfo.sessid == '-' && this.userInfo.playerid == '-' && Constants.CLIENT_MULTI_CURRENCY[Constants.CLIENT_CODE]) {
      this.commonService.openPlayerLogin();
      return false;
    }
    if (this.userData.noOfPanel == 0) {
      this.alertService.error(this.translate.instant('dge.add_bet_err'));
      return false;
    }
    this.drawService.setPayoutPanelStatus(false);
    this.removeBetPanels();
    this.drawService.setTicketStatus(true, this.userData);
    this.commonService.iframe_resize();
  }

  navigateTicketList() {
    if (this.myTicketCount > 0) {
      this.router.navigate(['/dge/my-tickets']);
    } else {
      return false;
    }
  }

  loadBack() {
    if (this.loadLobby || this.drawService.fromDrawMachine) {
      this.router.navigate(['/dge/lobby']);
    } else {
      this.commonService.appLobbyBack();
      this.commonService.redirectParent('loadBackUrl');
    }
  }

}
